import React from 'react';
import { connect } from 'react-redux';
import SystemCohortPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from './SystemCohortPanelContainer';
import CohortErrorMessages from '../../components/CohortErrorMessages';
import CohortNoDatasetAccess from '../../containers/CohortNoDatasetAccess';
import CohortInfoGrid from '../../components/CohortInfoGrid';
import SystemCohortMessage from '../components/SystemCohortMessage';

const SystemCohortPanelFull = ({
  code, // requestCode
  cohortCode,
  category,
  readErrors,
  validationErrors,
  updateProperties,
  onChange,
  url,
  queryAccess,
  allowCohortVisualisations,
  activeQueryUUID,
  expandedCharts,
  request,
  userCohort,
}) => (
  <SystemCohortPanelContainer
    code={code}
    category={category}
    onChange={onChange}
    url={url}
  >
    <div className="aridhia-system-cohort-panel-full">
      <CohortErrorMessages
        code={code}
        category={category}
        entities={['server', 'cohort', 'query', 'clause', 'filter']}
        isSystemCohort
        readErrors={readErrors}
        validationErrors={validationErrors}
        updateProperties={updateProperties}
      />
      {!queryAccess && (<CohortNoDatasetAccess code={code} category={category} />)}
      {cohortCode && (
        <>
          <SystemCohortMessage request={request} userCohort={userCohort} />
          <CohortInfoGrid
            code={cohortCode}
            category={category}
            queryAccess={queryAccess}
            queryUUID={activeQueryUUID}
            allowCohortVisualisations={allowCohortVisualisations}
            expandedCharts={expandedCharts}
          />
        </>
      )}
    </div>
  </SystemCohortPanelContainer>
);

export default connect(mapStateToProps, mapDispatchToProps)(SystemCohortPanelFull);
